// @flow
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import theme from '@sdk/theme/light';
import { ConfigProvider } from '@sdk/config/ConfigContext';
import { RequestProgressProvider } from '@sdk/components/ui/RequestProgress/RequestProgressContext';
import { LoginContextProvider } from '@sdk/login/LoginContext';
import RequestProgress from '@sdk/components/ui/RequestProgress';
// @TODO: better handling of polyfills - don't include them in bundle if they are not needed
import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import './polyfills/array.find';
import './polyfills/endsWith';
import './assets/css/fonts.css';
import './assets/css/index.css';

import Routing from './Routing';
import bugsnag from './bugsnag';
import getConfig from './config/getConfig';

const { ErrorBoundary } = bugsnag;

const container = document.getElementById('root');
const root = createRoot(container);
const config = getConfig();

if (root) {
  root.render(
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <ConfigProvider config={config}>
          <LoginContextProvider
            promoCode={null}
            redirectUrl=""
            firstName={null}
            lastName={null}
            fromToast={false}
            entitlements={null}>
            <RequestProgressProvider>
              <RequestProgress />
              <BrowserRouter>
                <Routing />
              </BrowserRouter>
            </RequestProgressProvider>
          </LoginContextProvider>
        </ConfigProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
